/* This file is autogenerated, see readme.md for instructions */
import TransferSvgIcon from '@bloomreach/banana-theme/icons/transfer.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const TransferIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <TransferSvgIcon />
    </Icon>
  );
});

TransferIcon.displayName = 'TransferIcon';

export default TransferIcon;
